import React from 'react';
import { findDOMNode } from 'react-dom';
import { TimelineLite } from 'gsap';
import ScrollMagic from "../../plugins/ScrollMagic";

export default {

    destroy(controller) {
        controller.destroy(true);
    },

    initialise(ThreeColumnIcons) {
        this.Node = findDOMNode(ThreeColumnIcons);
        this.icons = [...this.Node.querySelectorAll('.item img')];
        this.headings = [...this.Node.querySelectorAll('.item h3')];

        let controller = new ScrollMagic.Controller(),
            tl = new TimelineLite();

        if (this.icons.length > 0 && this.headings.length > 0) {
            tl
                .staggerFromTo(this.icons, 0.5, {y: -75, opacity: 0, scale: 0.5}, {
                    y: 0,
                    opacity: 1,
                    scale: 1
                }, 0.1, 0)
                .staggerFromTo(this.headings, 0.5, {y: 75, opacity: 0, scale: 0.5}, {
                    y: 0,
                    opacity: 1,
                    scale: 1
                }, 0.1, 0);
        }

        new ScrollMagic.Scene({
            triggerElement: this.Node,
            reverse: false
        })
            .setTween(tl)
            .addTo(controller);

        return controller;
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/modules/ThreeColumnIcons/animations.js